import { render, staticRenderFns } from "./fs-pill-color.vue?vue&type=template&id=05cb85d4&scoped=true"
import script from "./fs-pill-color.vue?vue&type=script&lang=js"
export * from "./fs-pill-color.vue?vue&type=script&lang=js"
import style0 from "./fs-pill-color.vue?vue&type=style&index=0&id=05cb85d4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cb85d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05cb85d4')) {
      api.createRecord('05cb85d4', component.options)
    } else {
      api.reload('05cb85d4', component.options)
    }
    module.hot.accept("./fs-pill-color.vue?vue&type=template&id=05cb85d4&scoped=true", function () {
      api.rerender('05cb85d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/pills/fs-pill-color.vue"
export default component.exports